import { Popover } from "antd-mobile"
import styled from "styled-components"

export const MealTypeValueBox = styled.div<{ $isActive: boolean }>`
  display: flex;
  align-items: center;
  gap: 4px;

  border-radius: 99px;
  background: ${(props) => (props.$isActive ? "#1C1F21" : "#1C1F21")};
  cursor: pointer;
  padding: var(--spacing_xxs, 4px) var(--spacing_m, 12px)
    var(--spacing_xxs, 4px) var(--spacing_l, 16px);
`

export const MealTypeValue = styled.p<{ $hasValue: boolean }>`
  font-size: 16px;
  font-weight: 600;
  line-height: 160%;
  color: #fff;
`
